import { Component, OnInit } from '@angular/core';
import {PageService} from "./services/page.service";
import {Page} from "./models/page";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-pageview',
    template: `
    
    <section class="content-header">
    <h1>
        {{ title }}
    </h1>
    <ol class="breadcrumb">
        <li><a href="#" routerLink="/home"><i class="fa fa-dashboard"></i> Dashboard</a></li>
        <li><a href="#" routerLink="/audio"> Pages</a></li>
        <li class="active">{{ pageinfo?.Title }}</li>
    </ol>
</section>
<section class="content">
    <div class="row">
        <div class="col-md-12">
            <div class="box box-solid">
                <div class="box-header with-border">
                    <h3 class="box-title">{{ pageinfo?.vTitle }}</h3>
                    <div class="pull-right">
                        <a href="#" routerLink="/pages/update/{{ pageinfo?.PagesId }}" class="btn btn-md btn-success btn-flat">Update</a>
                    </div>
                </div>
                <!-- /.box-header -->
                <div class="box-body">
                    <table id="w0" class="table table-striped table-bordered detail-view">
                        <tbody>
                        <tr>
                            <th>Title</th>
                            <td>{{ pageinfo?.Title }}</td>
                        </tr>
                        <tr>
                            <th>Description</th>
                            <td>{{ pageinfo?.Description }}</td>
                        </tr>
                        <tr>
                            <th>Create Date</th>
                            <td>{{ pageinfo?.iCreatedAt * 1000 | date }}</td>
                        </tr>
                        <tr>
                            <th>Update Date</th>
                            <td>{{ pageinfo?.iUpdatedAt * 1000 | date }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </div>
</section>
    
    `
})
export class PageviewComponent implements OnInit {
    title:string = "Pages";
    pageinfo:Page;
    constructor(
        private pageService:PageService,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit() {
        this.title;
        this.getPageInfo();
    }

    getPageInfo=function () {
        this.activatedRoute.params.subscribe(params => {
            let iPageId = params['id'];
            console.log("iPageId======>",iPageId); // Print the parameter to the console.
            this.pageService.getPageInfo(iPageId).then(data => {
                console.log("PageInfo=======>",data['data']);
                this.pageinfo = data['data'];
            });
        });

    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/pages/pageview.component.ts